import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import ProjectUtils from "../../../../../utils/project-utils.js";
import projectUtils from "../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {tableSortHeader} from "../../../../../components/reports/table-sort-header/table-sort-header.jsx";
import Button from "../../../../../components/button/button.jsx";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";

const ReportContent = ({data, tableColumns, filters}) => {
    const navigate = navigateHook();

    const navigateToSosHistory = (citizenId) => {
        const filtersToReport = {
            dtStart: filters.dtStart,
            dtEnd: filters.dtEnd,
            citizenId
        };
        const encodedFilters = btoa(encodeURIComponent(JSON.stringify(filtersToReport)).replace(/%([0-9A-F]{2})/g, (_, code) => String.fromCharCode(parseInt(code, 16))));

        navigate(`/reports/sos_history?d=${encodeURIComponent(encodedFilters)}`, true);
    };

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Lista de protegidos`, "sos-records-data");
    }, [data]);

    const getProtectedPlaceText = (element) => {
        if (!element) return "";

        const {latitude, longitude, address, number, city, neighborhood, name, addressType, description} = element;

        return [
            name,
            addressType && (name ? ", " : "") + addressType,
            address && (name || addressType ? ", " : "") + address,
            number && (name || addressType || address ? ", " : "") + number,
            neighborhood && (name || addressType || address || number ? " - " : "") + neighborhood,
            city && (name || addressType || address || number || neighborhood ? ", " : "") + city,
            description && (name || addressType || address || number || neighborhood || city ? ", " : "") + description,
            latitude && (name || addressType || address || number || neighborhood || city || description ? ", " : "") + "(Lat: " + latitude,
            longitude && (name || addressType || address || number || neighborhood || city || description || latitude ? ", " : "") + "Long: " + longitude + ")"
        ].filter(Boolean).join("");
    };

    const renderProtectedPlaces = (data) => {
        if (!Array.isArray(data) || data.length === 0) return null;

        return (
            <ul style={{listStyle: "none"}}>
                {data.map((element, index) => (
                    element && <li key={index} className="mb-2">{getProtectedPlaceText(element)} {"\u2009"}</li>
                ))}
            </ul>
        );
    };

    const sortValueExtraction = {
        cpf: (row) => row.cpf ? projectUtils.formatCpfToView(row.cpf) : projectUtils.formatCnpjToView(row.cnpj),
        addresses: (row) => Array.isArray(row.addresses) ? row.addresses.map(getProtectedPlaceText).filter(Boolean).join(" ").normalize("NFD").replace(/[\u0300-\u036f]/g, "") : ""
    };

    const { order, handleSort, sortedData, getIcon } = tableSortHeader(data ?? [], sortValueExtraction);
    const columns = [
        {
            id: "life_risk",
            label: tableColumns.life_risk.label,
            sortField: "life_risk",
            headerClassName: "w-[5%] cursor-pointer",
            cellClassName: "w-[5%]",
            renderCell: (element) => element.life_risk ?? ""
        },
        {
            id: "citizen_name",
            label: tableColumns.citizen_name.label,
            sortField: "citizen_name",
            headerClassName: "w-[11%] cursor-pointer",
            cellClassName: "w-[11%]",
            renderCell: (element) => <a onClick={() => navigate(`/sos/citizens/form/${element.citizen_id}`, true)} className="inner-link" title="Acessar cadastro do protegido">{element.citizen_name ?? ""}</a>
        },
        {
            id: "protection_programs",
            label: tableColumns.protection_programs.label,
            sortField: "protection_programs",
            headerClassName: "w-[10%] cursor-pointer",
            cellClassName: "w-[10%]",
            renderCell: (element) => element.protection_programs ?? ""
        },
        {
            id: "citizen_status",
            label: tableColumns.citizen_status.label,
            sortField: "citizen_status",
            headerClassName: "w-[6%] cursor-pointer",
            cellClassName: "w-[6%]",
            renderCell: (element) => element.citizen_status ?? ""
        },
        {
            id: "cpf",
            label: tableColumns.cpf.label,
            sortField: "cpf",
            headerClassName: "w-[9%] cursor-pointer",
            cellClassName: "w-[9%]",
            renderCell: (element) => element.cpf ? projectUtils.formatCpfToView(element.cpf) : projectUtils.formatCnpjToView(element.cnpj)
        },
        {
            id: "phone",
            label: tableColumns.phone.label,
            sortField: "phone",
            headerClassName: "w-[9%] cursor-pointer",
            cellClassName: "w-[9%]",
            renderCell: (element) => ProjectUtils.formatPhone(element.phone)
        },
        {
            id: "citizen_registration_dt",
            label: tableColumns.citizen_registration_dt.label,
            sortField: "citizen_registration_dt",
            headerClassName: "w-[9%] cursor-pointer",
            cellClassName: "w-[9%]",
            renderCell: (element) => element.citizen_registration_dt ?? ""
        },
        {
            id: "last_login_dt",
            label: tableColumns.last_login_dt.label,
            sortField: "last_login_dt",
            headerClassName: "w-[9%] cursor-pointer",
            cellClassName: "w-[9%]",
            renderCell: (element) => element.last_login_dt ?? ""
        },
        {
            id: "no_app",
            label: tableColumns.no_app.label,
            sortField: "no_app",
            headerClassName: "w-[6%] cursor-pointer",
            cellClassName: "w-[6%]",
            renderCell: (element) => element.no_app ? "Sim" : "Não"
        },
        {
            id: "addresses",
            label: tableColumns.addresses.label,
            sortField: "addresses",
            headerClassName: "w-[18%] cursor-pointer",
            cellClassName: "w-[18%]",
            renderCell: (element) => renderProtectedPlaces(element.addresses)
        },
        {
            id: "actions",
            label: tableColumns.actions.label,
            headerLabel: "",
            headerClassName: "w-[6%] export-ignore print:hidden! print:display-none!",
            cellClassName: "w-[6%] export-ignore print:hidden! print:display-none!",
            renderCell: (element) => (
                <div className="flex flex-row items-center justify-center w-full mx-auto!">
                    <Button target="primary" title="Acessar Histórico operacional do SOS" onClick={() => navigateToSosHistory(element.citizen_id)}>
                        <img src={getAssetPath("/img/dashboard-svg/sw.sos.inverted.svg")} className="h-5 w-5 min-h-5 min-w-5" alt="sos"/>
                    </Button>
                </div>
            )
        },
    ];

    const visibleColumns = columns.filter(column => tableColumns[column.id].visible);
    const printableColumns = visibleColumns.filter(column => tableColumns[column.id].printIgnore !== true);
    const onlyPrintIgnoredColumns = visibleColumns.length > 0 && printableColumns.length === 0;

    return (
        <>
            {visibleColumns.length ? (
                <>
                    <table id="sos-records-data" className={`table report-table ${onlyPrintIgnoredColumns ? "print:hidden" : ""}`} sheet-name="Lista de protegidos">
                        <thead className="thead-background print:table-row-group!">
                            <tr className="bg-[#f6f6f6] text-left">
                                {visibleColumns.map((column) => (
                                    <th key={column.id} onClick={column.sortField ? () => handleSort(column.sortField) : undefined} className={column.headerClassName}>
                                        {column.headerLabel ?? column.label} {column.sortField && getIcon(order, column.sortField)}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {sortedData.map((element, index) => (
                                <React.Fragment key={index}>
                                    <tr className={`table-break-word`}>
                                        {visibleColumns.map((column) => (
                                            <td key={column.id} className={column.cellClassName}>{column.renderCell(element)}</td>
                                        ))}
                                    </tr>
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                    {onlyPrintIgnoredColumns && <div className="hidden print:block alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
                </>
            ) : <div id="noDataMessage" className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;